/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AggregateLevel = "DAY" | "MONTH" | "YEAR" | "%future added value";
export type FinancialAggregatedNumber = "accruedDeferred" | "actualCost" | "actualLockedRevenue" | "actualMargin" | "actualOpenRevenue" | "actualProfit" | "actualRevenue" | "actualRevenueMargin" | "actualRevenueProfit" | "allActualTimeAndExpenses" | "allForecastTimeAndExpensesToComplete" | "allPlannedTimeAndExpenses" | "allTotalTimeAndExpensesAtCompletion" | "allocationMinutes" | "baselineCost" | "baselineMargin" | "baselineMinutes" | "baselineProfit" | "baselineRevenue" | "baselineTimeAndExpenses" | "baselineVsActualCost" | "baselineVsActualMargin" | "baselineVsActualProfit" | "baselineVsActualRevenue" | "baselineVsActualRevenueMargin" | "baselineVsActualRevenueProfit" | "baselineVsActualRevenueRecognition" | "baselineVsAllActualValueOfService" | "baselineVsAllProjectedValueOfService" | "baselineVsBillableActualTimeAndExpenses" | "baselineVsBillableTotalTimeAndExpensesAtCompletion" | "baselineVsForecastCost" | "baselineVsForecastMinutes" | "baselineVsForecastProfit" | "baselineVsForecastRevenue" | "baselineVsRegisteredMinutes" | "baselineVsTotalCostAtCompletion" | "baselineVsTotalMarginAtCompletion" | "baselineVsTotalProfitAtCompletion" | "baselineVsTotalRevenueAtCompletion" | "baselineVsTotalRevenueMarginAtCompletion" | "baselineVsTotalRevenueProfitAtCompletion" | "baselineVsTotalTimeAtCompletion" | "billableActualMinutes" | "billableActualTimeAndExpenses" | "billableForecastTimeAndExpensesToComplete" | "billablePlannedTimeAndExpenses" | "billableTime" | "billableTotalTimeAndExpensesAtCompletion" | "estimatedCost" | "estimatedCostPercentage" | "estimatedVsAllActualValueOfService" | "estimatedVsAllProjectedValueOfService" | "expenseCostPercentage" | "expenseRevenuePercentage" | "forecastCost" | "forecastCostToComplete" | "forecastLockedRevenueToComplete" | "forecastMargin" | "forecastMarginToComplete" | "forecastMinutes" | "forecastOpenRevenueToComplete" | "forecastProfit" | "forecastProfitToComplete" | "forecastRevenue" | "forecastRevenueMarginToComplete" | "forecastRevenueProfitToComplete" | "forecastTimeToComplete" | "forecastVsScopeApprovedMinutes" | "invoiced" | "nonBillableActualMinutes" | "nonBillableActualTimeAndExpenses" | "nonBillableForecastTimeAndExpensesToComplete" | "nonBillablePlannedTimeAndExpenses" | "nonBillableTotalTimeAndExpensesAtCompletion" | "paid" | "planVsActualCost" | "planVsActualMargin" | "planVsActualProfit" | "planVsActualRevenue" | "planVsActualRevenueMargin" | "planVsActualRevenueProfit" | "planVsActualRevenueRecognition" | "planVsBillableActualTimeAndExpenses" | "planVsForecastCost" | "planVsForecastProfit" | "planVsForecastRevenue" | "planVsTotalBillableTimeAndExpensesAtCompletion" | "planVsTotalCostAtCompletion" | "planVsTotalMarginAtCompletion" | "planVsTotalProfitAtCompletion" | "planVsTotalRevenueAtCompletion" | "planVsTotalRevenueMarginAtCompletion" | "planVsTotalRevenueProfitAtCompletion" | "plannedCost" | "plannedMargin" | "plannedProfit" | "plannedRevenue" | "plannedRevenueMargin" | "plannedRevenueProfit" | "projectedTotalRevenueVsProjectedTotalBillableValueOfService" | "projectedTotalRevenueVsProjectedTotalValueOfService" | "recognitionActualProfit" | "recognitionActualProfitPercentage" | "recognitionAmount" | "recognitionForecastRevenue" | "recognitionLockedProfit" | "recognitionLockedProfitPercentage" | "recognitionLockedRevenue" | "recognitionOpenRevenue" | "recognitionPercentage" | "recognitionProfit" | "recognitionProfitPercentage" | "registeredMinutes" | "registeredVsScopeApprovedMinutes" | "remainingCost" | "remainingMargin" | "remainingMinutes" | "remainingProfit" | "remainingRevenue" | "retainerPeriodRolloverMinutes" | "retainerPeriodRolloverPrice" | "retainerPeriodTargetMinutes" | "retainerPeriodTargetPrice" | "scopeApprovedMinutes" | "scopeApprovedVsForecastMinutes" | "scopeApprovedVsRegisteredMinutes" | "scopeApprovedVsTotalTimeAtCompletion" | "scopeTotalMinutes" | "suggestedProfit" | "suggestedProfitPercentage" | "suggestedRevenue" | "suggestedRevenuePercentage" | "surplus" | "surplusPercentage" | "totalActualRevenueRecognition" | "totalCostAtCompletion" | "totalForecastRevenueToComplete" | "totalMarginAtCompletion" | "totalProfitAtCompletion" | "totalRevenueMarginAtCompletion" | "totalRevenueProfitAtCompletion" | "totalRevenueRecognition" | "totalTimeAtCompletion" | "totalTimeAtCompletionVsScopeApprovedMinutes" | "%future added value";
export type GLOBAL_FILTER_CONTEXT = "INVOICES" | "LABELS" | "PEOPLE" | "PLACEHOLDERS" | "PROJECTS" | "RESOURCES" | "SKILLS" | "TASKS" | "TIME_REGS" | "%future added value";
export type GLOBAL_FILTER_FIELD = "APPROVAL_STATUS" | "ASSIGNED" | "ASSIGNED_SELF" | "BILLABLE" | "BILLABLE_TIME_REG" | "BILL_FROM" | "BILL_TO" | "BLOCKED" | "BUG" | "CLIENT" | "CLIENT_GUEST_USERS" | "CLIENT_TIME_REG" | "COMPANY_TASK_ID" | "CONTACT" | "CREATED_AT" | "DEADLINE" | "DEPARTMENT" | "DEPARTMENT_TIME_REG" | "DEPENDENCIES" | "DESCRIPTION" | "END_DATE" | "END_DATE_PROJECT" | "END_DATE_TIME_REG" | "FILTER_BY_TIME_REG_SETTINGS" | "FOLLOWER" | "FORECAST" | "HIGH_PRIORITY" | "INTERNAL_TIME" | "INTERNAL_TIME_REG" | "INVOICED" | "LABELS" | "LABEL_TIME_REG" | "NAME" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "NON_TASK_TIME_REG" | "NO_CONTACT" | "OWNER" | "PERMISSION_LEVEL" | "PERSON" | "PERSON_TIME_REG" | "PHASE_CATEGORY" | "PHASE_TIME_REG" | "PRIORITY_LEVEL" | "PROGRAM" | "PROJECT" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "PROJECT_FOLLOWER" | "PROJECT_GROUP" | "PROJECT_GROUP_SPRINT" | "PROJECT_GROUP_STATUS" | "PROJECT_LABELS" | "PROJECT_MANUAL_PROGRESS" | "PROJECT_OWNER" | "PROJECT_PERSON" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_STAGE" | "PROJECT_STATUS" | "PROJECT_TIME_REG" | "PROJECT_WIN_CHANCE" | "RATE_CARD" | "RECENT_ACTIVITY" | "RECENT_TASK_ACTIVITY" | "RECENT_TIME" | "REMAINING" | "RETAINER_PERIOD" | "ROLE" | "ROLE_TIME_REG" | "SET_DONE_AT" | "SKILL" | "SPRINT_CATEGORY" | "SPRINT_TIME_REG" | "STARRED" | "START_DATE" | "START_DATE_PROJECT" | "START_DATE_TIME_REG" | "STATUS" | "SUB_TASKS" | "TASK" | "TASK_APPROVED" | "TASK_HIERARCHY" | "TASK_LEVEL" | "TASK_TIME_REG" | "TEAM" | "TEAM_MEMBER" | "TEAM_TIME_REG" | "TIME_OFF" | "TIME_OFF_TIME_REG" | "TIME_REGS" | "UPDATED_AT" | "WITH_TASKS" | "WITH_TIME_REG" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "ALL_IN" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "IN" | "IS" | "IS_ALL" | "IS_NOT" | "IS_NOT_ALL" | "LESS" | "LESS_OR_EQUAL" | "NOT_ALL_IN" | "NOT_IN" | "%future added value";
export type TaskSearchQueryType = {
    filters?: Array<GlobalSearchFilterType | null> | null | undefined;
};
export type GlobalSearchFilterType = {
    field?: GLOBAL_FILTER_FIELD | null | undefined;
    operator?: GLOBAL_FILTER_OPERATOR | null | undefined;
    value?: Array<string | null> | null | undefined;
    context?: GLOBAL_FILTER_CONTEXT | null | undefined;
    filters?: Array<GlobalSearchFilterType | null> | null | undefined;
    logicalOperator?: GLOBAL_FILTER_LOGICAL_OPERATOR | null | undefined;
};
export type RevenueRecognitionLoader_QueryVariables = {
    projectId: string;
    startYear?: number | null | undefined;
    startMonth?: number | null | undefined;
    startDay?: number | null | undefined;
    endYear?: number | null | undefined;
    endMonth?: number | null | undefined;
    endDay?: number | null | undefined;
    aggregateLevel: AggregateLevel;
    aggregates: Array<FinancialAggregatedNumber | null>;
    searchQuery?: TaskSearchQueryType | null | undefined;
    expenseAggregates: Array<FinancialAggregatedNumber | null>;
    expenseSearchQuery?: TaskSearchQueryType | null | undefined;
    hasExpenses: boolean;
};
export type RevenueRecognitionLoader_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"RevenueRecognitionLoader_viewer">;
    } | null;
};
export type RevenueRecognitionLoader_Query = {
    readonly response: RevenueRecognitionLoader_QueryResponse;
    readonly variables: RevenueRecognitionLoader_QueryVariables;
};



/*
query RevenueRecognitionLoader_Query(
  $projectId: ID!
  $startYear: Int
  $startMonth: Int
  $startDay: Int
  $endYear: Int
  $endMonth: Int
  $endDay: Int
  $aggregateLevel: AggregateLevel!
  $aggregates: [FinancialAggregatedNumber]!
  $searchQuery: TaskSearchQueryType
  $expenseAggregates: [FinancialAggregatedNumber]!
  $expenseSearchQuery: TaskSearchQueryType
  $hasExpenses: Boolean!
) {
  viewer {
    actualPersonId
    component(name: "revenue_recognition_loader")
    ...RevenueRecognitionLoader_viewer_1FfX2a
    id
  }
}

fragment RevenueRecognitionLoader_viewer_1FfX2a on Viewer {
  id
  company {
    currency
    id
  }
  project(internalId: $projectId) {
    rateCard {
      currency
      id
    }
    aggregatedFinancialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: $aggregateLevel, aggregates: $aggregates, convertToProjectCurrency: true, addAccumulatedNumbers: true)
    financialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, convertToProjectCurrency: true) {
      recognitionAmount
      estimatedCost
      recognitionProfit
      recognitionProfitPercentage
    }
    workAggregatedFinancialNumbers: aggregatedFinancialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: $aggregateLevel, aggregates: $aggregates, convertToProjectCurrency: true, addAccumulatedNumbers: true, searchQuery: $searchQuery) @include(if: $hasExpenses)
  workFinancialNumbers: financialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, convertToProjectCurrency: true, searchQuery: $searchQuery) @include(if: $hasExpenses) {
      recognitionAmount
    }
  expenseAggregatedFinancialNumbers: aggregatedFinancialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: $aggregateLevel, aggregates: $expenseAggregates, convertToProjectCurrency: true, addAccumulatedNumbers: true, searchQuery: $expenseSearchQuery) @include(if: $hasExpenses)
  expenseFinancialNumbers: financialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, convertToProjectCurrency: true, searchQuery: $expenseSearchQuery) @include(if: $hasExpenses) {
      billableTotalTimeAndExpensesAtCompletion
      allTotalTimeAndExpensesAtCompletion
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startYear",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startMonth",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startDay",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endYear",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endMonth",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endDay",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aggregateLevel",
    "type": "AggregateLevel!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aggregates",
    "type": "[FinancialAggregatedNumber]!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchQuery",
    "type": "TaskSearchQueryType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "expenseAggregates",
    "type": "[FinancialAggregatedNumber]!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "expenseSearchQuery",
    "type": "TaskSearchQueryType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hasExpenses",
    "type": "Boolean!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "revenue_recognition_loader"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"revenue_recognition_loader\")"
},
v3 = {
  "kind": "Variable",
  "name": "aggregateLevel",
  "variableName": "aggregateLevel"
},
v4 = {
  "kind": "Variable",
  "name": "aggregates",
  "variableName": "aggregates"
},
v5 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v6 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v7 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v8 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v9 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v10 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v11 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  (v12/*: any*/)
],
v14 = {
  "kind": "Literal",
  "name": "addAccumulatedNumbers",
  "value": true
},
v15 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recognitionAmount",
  "storageKey": null
},
v17 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "expenseSearchQuery"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RevenueRecognitionLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "Variable",
                "name": "expenseAggregates",
                "variableName": "expenseAggregates"
              },
              {
                "kind": "Variable",
                "name": "expenseSearchQuery",
                "variableName": "expenseSearchQuery"
              },
              {
                "kind": "Variable",
                "name": "hasExpenses",
                "variableName": "hasExpenses"
              },
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              },
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "RevenueRecognitionLoader_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RevenueRecognitionLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "internalId",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v14/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v15/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "aggregatedFinancialNumbers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v15/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimatedCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionProfitPercentage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v12/*: any*/),
              {
                "condition": "hasExpenses",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "workAggregatedFinancialNumbers",
                    "args": [
                      (v14/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v15/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/)
                    ],
                    "kind": "ScalarField",
                    "name": "aggregatedFinancialNumbers",
                    "storageKey": null
                  },
                  {
                    "alias": "workFinancialNumbers",
                    "args": [
                      (v15/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/)
                    ],
                    "concreteType": "FinancialNumbers",
                    "kind": "LinkedField",
                    "name": "financialNumbers",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "expenseAggregatedFinancialNumbers",
                    "args": [
                      (v14/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "Variable",
                        "name": "aggregates",
                        "variableName": "expenseAggregates"
                      },
                      (v15/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v17/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/)
                    ],
                    "kind": "ScalarField",
                    "name": "aggregatedFinancialNumbers",
                    "storageKey": null
                  },
                  {
                    "alias": "expenseFinancialNumbers",
                    "args": [
                      (v15/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v17/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/)
                    ],
                    "concreteType": "FinancialNumbers",
                    "kind": "LinkedField",
                    "name": "financialNumbers",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "billableTotalTimeAndExpensesAtCompletion",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "allTotalTimeAndExpensesAtCompletion",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "RevenueRecognitionLoader_Query",
    "operationKind": "query",
    "text": "query RevenueRecognitionLoader_Query(\n  $projectId: ID!\n  $startYear: Int\n  $startMonth: Int\n  $startDay: Int\n  $endYear: Int\n  $endMonth: Int\n  $endDay: Int\n  $aggregateLevel: AggregateLevel!\n  $aggregates: [FinancialAggregatedNumber]!\n  $searchQuery: TaskSearchQueryType\n  $expenseAggregates: [FinancialAggregatedNumber]!\n  $expenseSearchQuery: TaskSearchQueryType\n  $hasExpenses: Boolean!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"revenue_recognition_loader\")\n    ...RevenueRecognitionLoader_viewer_1FfX2a\n    id\n  }\n}\n\nfragment RevenueRecognitionLoader_viewer_1FfX2a on Viewer {\n  id\n  company {\n    currency\n    id\n  }\n  project(internalId: $projectId) {\n    rateCard {\n      currency\n      id\n    }\n    aggregatedFinancialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: $aggregateLevel, aggregates: $aggregates, convertToProjectCurrency: true, addAccumulatedNumbers: true)\n    financialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, convertToProjectCurrency: true) {\n      recognitionAmount\n      estimatedCost\n      recognitionProfit\n      recognitionProfitPercentage\n    }\n    workAggregatedFinancialNumbers: aggregatedFinancialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: $aggregateLevel, aggregates: $aggregates, convertToProjectCurrency: true, addAccumulatedNumbers: true, searchQuery: $searchQuery) @include(if: $hasExpenses)\n  workFinancialNumbers: financialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, convertToProjectCurrency: true, searchQuery: $searchQuery) @include(if: $hasExpenses) {\n      recognitionAmount\n    }\n  expenseAggregatedFinancialNumbers: aggregatedFinancialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: $aggregateLevel, aggregates: $expenseAggregates, convertToProjectCurrency: true, addAccumulatedNumbers: true, searchQuery: $expenseSearchQuery) @include(if: $hasExpenses)\n  expenseFinancialNumbers: financialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, convertToProjectCurrency: true, searchQuery: $expenseSearchQuery) @include(if: $hasExpenses) {\n      billableTotalTimeAndExpensesAtCompletion\n      allTotalTimeAndExpensesAtCompletion\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'a17519c1265d7e45f255c9e2344d8288';
export default node;
